import BreadCrumbComponent from "../components/Items/BreadCrumb/Index";
import MasterStaffRouterDetailsComponent from "../components/master-staff/MasterStaffRouterDetailsComponent";

const MasterStaffRouterDetailsPage = () => {
  return (
    <>
      <BreadCrumbComponent
        lastItem="Router Details"
        routes={[
          { title: "Home", path: "/" },
        ]}
      />
      <MasterStaffRouterDetailsComponent />
    </>
  );
};

export default MasterStaffRouterDetailsPage;
